import React, { Component, Fragment } from 'react'
import {
  Row,
  Col,
  Collapse,
  Card,
  Icon,
  Breadcrumb,
  Divider,
  Popover,
} from 'antd'
import { Link } from 'react-router-dom'
import LangContext, { i18n } from 'modules/shared/context/langContext'

class Index extends Component {
  static contextType = LangContext

  render() {
    const { checkMenuVisibility, web_endpoint, permissions } = this.props
    return (
      <>
        <div className="divider__web__content">
          <Divider />
        </div>
        {/* การแจ้งซ่อม */}
        {checkMenuVisibility(
          '',
          web_endpoint,
          'repairingReport',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/report/repairingreport">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report2__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.r.repairingReport}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          รายงานแสดงสถานะการแจ้งซ่อมของอุปกรณ์ GPS
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{ fontSize: 'larger', paddingTop: 17 }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
              </Card>
            </Link>
          </Col>
        )}
        {/* GPS ขาดการติดต่อ */}
        {checkMenuVisibility(
          '',
          web_endpoint,
          'gpsReportLostContact',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/report/gps-lost-contact">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report2__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.g.gpsReportLostContact}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          รายงานแสดงข้อมูลพาหนะที่ GPS ขาดการติดต่อ
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{ fontSize: 'larger', paddingTop: 17 }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
              </Card>
            </Link>
          </Col>
        )}
        {/* gpsDisconnectOnTrip */}
        {checkMenuVisibility(
          '',
          web_endpoint,
          'gpsDisconnectOnTrip',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/report/gps-disconnect-on-trip">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.g.gpsDisconnectOnTrip}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          รายงานแสดงพาหนะที่ GPS ขาดการติดต่อขณะวิ่งงาน
                          สำหรับให้ทาง GPS Vendor ตรวจสอบประสิทธิภาพการทำงานของ
                          GPS
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{ fontSize: 'larger', paddingTop: 17 }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
              </Card>
            </Link>
          </Col>
        )}
        {/* gpsDisconnectOnTrip */}
        {checkMenuVisibility(
          '',
          web_endpoint,
          'distance_report_1',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="distancereport">
              <Card className="card__web__content">
                <p className="text__card__web__content">{this.context.d.deliveryDistance}</p>
              </Card>
            </Link>
          </Col>
        )}
      </>
    )
  }
}

export default Index
